import container from "@/lib/di/container";
import { useEffect, useState } from "react";
import { FilterBar, FilterInputTemplate, FilterInputType } from "../../components/filter/FilterBar";
import { FilterSearchPayload, DataTable } from "../../components/table/DataTable";
import { DetailModal } from "./modals/DetailModal";
import { Button, Dropdown, message, Popconfirm, Tooltip } from "antd";
import { DeleteOutlined, InfoCircleOutlined, MoreOutlined, PlusOutlined, TableOutlined } from "@ant-design/icons";
import { suspensionStatusPipe } from "@/core/pipes/suspension-status.pipe";
import { FeeLadderRepo } from "@/core/repos/tables/fee-ladder.repo";
import { FeeLadderModel, FeeLadderModelFactory } from "@/core/models/fee-ladder.model";
import { cubicMeterPipe, percentagePipe } from "@/core/pipes/unit.pipe";
import { useTitleDataStore } from "@/core/stores/title-data.store";
import { usePermissionStore } from "@/core/stores/permission.store";
import { DeleteButton } from "../../components/table/DeleteButton";
import { useLocation, useNavigate } from "react-router";

const feeLadderRepo = container.get(FeeLadderRepo);

export default function FeeLadderPage() {
    const navigate = useNavigate();
    const {pathname} = useLocation();
    const titleData = useTitleDataStore();
    const permissionStore = usePermissionStore();
    const [modalData, setModalData] = useState<FeeLadderModel>(FeeLadderModelFactory.getEmpty())
    const [filterMap, setFilterMap] = useState<Map<string, FilterSearchPayload>>(new Map())
    const [selectedRows, setSelectedRows] = useState<FeeLadderModel[]>([]);
    const [isDetailModal, setDetailModal] = useState(false);
    const [deleting, setDeleting] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();
    const [filterTemplates] = useState<FilterInputTemplate[]>([
        {
            dataIndex: "search",
            label: "Tìm kiếm",
            placeholder: "Nhập nội dung tìm kiếm",
            type: FilterInputType.text,
        },
    ])

    const showDetail = (record: FeeLadderModel) => {
        setModalData(record);
        setDetailModal(true);
    };

    const showLevels = (record: FeeLadderModel) => {
        navigate(encodeURI(`${pathname}/level?id=${record.id}`))
    };

    const init = async () => {
        titleData.setTitleActions({
            text: "Thêm bảng giá",
            onPress: () => {
                showDetail(FeeLadderModelFactory.getEmpty())
            }
        })
    }

    useEffect(()=>{init()}, []);

    const deleteSelected = async () => {
        setDeleting(true);
        const result = await feeLadderRepo.deleteMany(selectedRows);
        messageApi.success({
            content: `Bạn đã xoá thành công ${result.success}/${result.total} bản ghi`
        })
        setDeleting(false);
    }


    async function onFilterChange(map: Map<string, FilterSearchPayload>) {
        setFilterMap(new Map(map));
    }

    function onRowSelect(rows: FeeLadderModel[]) {
        setSelectedRows([...rows]);
    }

    return (
    <div className="px-4 py-6">
        {contextHolder}
        <FilterBar setMap={setFilterMap} onChange={onFilterChange} templates={filterTemplates} map={filterMap} actions={[
            <div key={1} className="mt-6">
                <DeleteButton loading={deleting} length={selectedRows.length} onConfirm={deleteSelected}/>
            </div>
        ]}/>
        <div className="mt-4 border-t border-dashed border-gray-300 pt-6">
            <DataTable<FeeLadderModel>
                columns={[
                    { dataIndex: 'name', name: 'Tên' },
                    { dataIndex: 'provinceName', name: 'Tỉnh/Thành phố áp dụng' },
                    { dataIndex: 'enviromentFee', name: 'Phí BVMT ', pipe: percentagePipe },
                    { dataIndex: 'vat', name: 'Phí giá trị gia tăng', pipe: percentagePipe },
                    { dataIndex: 'floorIndex', name: 'Chỉ số tính giá sàn', pipe: cubicMeterPipe },
                    { dataIndex: 'status', name: 'Trạng thái', pipe: suspensionStatusPipe },
                    {
                        name: 'Thao tác',
                        render: (_, record) => (
                                <div className="flex flex-row px-1 items-center justify-center">
                                    <Tooltip title="Sửa Bảng giá"><Button type="text" icon={<InfoCircleOutlined />} onClick={() => showDetail(record)}/></Tooltip>
                                    <Dropdown menu={{items: [
                                        {
                                            key: '1',
                                            label: <p>Chi tiết Bảng giá</p>,
                                            icon: <TableOutlined />,
                                            onClick: () => showLevels(record)
                                        }
                                    ]}} trigger={["hover"]}>
                                        <Button type="text" icon={<MoreOutlined />}/>
                                    </Dropdown>
                                </div>
                            ),
                        fixed: "right"
                    }
                ]}
                repository={feeLadderRepo}
                filterMap={filterMap}
                onSelect={onRowSelect}
            ></DataTable>
        </div>
        <DetailModal isModalOpen={isDetailModal} setIsModalOpen={setDetailModal} data={modalData}></DetailModal>
    </div>)
}